var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorFeatured = function SvgErrorFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    fillRule: "evenodd",
    d: "M10.667 20A9.333 9.333 0 0 0 20 29.333 9.333 9.333 0 0 0 29.333 20 9.333 9.333 0 0 0 20 10.667 9.333 9.333 0 0 0 10.667 20ZM20 8C13.373 8 8 13.373 8 20s5.373 12 12 12 12-5.373 12-12S26.627 8 20 8Zm-4.943 7.058c.52-.521 1.365-.521 1.886 0L20 18.115l3.057-3.057a1.333 1.333 0 1 1 1.886 1.885l-3.057 3.058 3.057 3.057a1.333 1.333 0 1 1-1.886 1.885L20 21.886l-3.057 3.057a1.333 1.333 0 1 1-1.886-1.885L18.114 20l-3.057-3.058a1.333 1.333 0 0 1 0-1.885Z",
    clipRule: "evenodd"
  })));
};
export default SvgErrorFeatured;